import React from 'react';
import cs from 'classnames';
import './index.less';

interface DividerProps {
    /** 使用 0.5px */
    halfHeight?: boolean;
}

const Divider: React.FC<DividerProps> = ({ halfHeight = true }) => {
    return <div className={cs('f-divider', { 'f-divider--half': halfHeight })} />;
};
export default Divider;
